var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { OutskirtBuilding, } from "../outskirts/OutskirtBuilding";
var OutskirtBuildingHarbor = /** @class */ (function (_super) {
    __extends(OutskirtBuildingHarbor, _super);
    function OutskirtBuildingHarbor() {
        var _this = _super.call(this, IdOutskirtBuildings.Harbor) || this;
        // TODO: remove after it is implementd (currently it is here only to pass `false` to optional param "isImplemented"
        _this.update = function (props) {
            _super.prototype.updateDisplay.call(_this, props);
            _this.baseUpdate(props, undefined, false);
        };
        return _this;
    }
    return OutskirtBuildingHarbor;
}(OutskirtBuilding));
export { OutskirtBuildingHarbor };



//////////////////
// WEBPACK FOOTER
// ./src/features/harbor/OutskirtBuildingHarbor.ts
// module id = 2174
// module chunks = 3